import classNames from 'classnames';
import Accordion from 'src/components/Accordion/Accordion';
import styles from 'src/components/AccordionItem/accordion-item.module.scss';
import { AccordionItemProps } from 'src/components/AccordionItem/AccordionItem';

type HairAccordionColumnsPros = {
    columns: AccordionItemProps[];
    className?: string;
};

const HairAccordionColumns = ({
    columns,
    className,
}: HairAccordionColumnsPros) => {
    const columnsArray = [
        [columns[0], columns[3]],
        [columns[1], columns[4]],
        [columns[2], columns[5]],
    ];
    return (
        <>
            {columnsArray.map((column, id) => (
                <Accordion
                    items={column}
                    key={id}
                    className={
                        className
                            ? className
                            : classNames(styles['accordion__column'])
                    }
                    border={false}
                />
            ))}
        </>
    );
};
export default HairAccordionColumns;
